import httpClient from '@/lib/httpClient.js'
import { useMutation, useQueryClient } from '@tanstack/react-query'
import { toast } from 'sonner'

export default function useCreateTransactionSeries() {
  const queryClient = useQueryClient()

  const action = async ({
    id,
    transaction_id,
    type,
    frequency,
    cron,
    date,
    vaultId,
    categoryId,
    fromVaultId,
    description = '',
    amount,
    modelId,
    is_skip_allocation,
    is_refund = false,
    ends_after_count = undefined,
    ends_after_date = undefined,
  }) => {
    const response = await httpClient.put(`team/cash-flow/series/${id}`, {
      transaction_id,
      type,
      frequency,
      cron,
      next_transaction_date: date,
      vault_id: vaultId,
      transaction_category_id: categoryId,
      from_vault_id: fromVaultId,
      transaction_description: description,
      amount,
      what_if_id: modelId,
      is_skip_allocation,
      is_refund,
      ends_after_count,
      ends_after_date,
    })
    return response
  }

  const mutation = useMutation({
    mutationFn: action,
    onError: (e) => {
      toast.error(e?.response?.data?.message ?? 'An error occurred.')
    },
    onSuccess: async (_data, variables) => {
      // Remove the detail entry for the original transaction before invalidating
      // the list. A series update re-creates the transaction with a new ID, so
      // the old detail query would 404 — removing it prevents that refetch from
      // ever firing, even if the edit form is still briefly mounted.
      queryClient.removeQueries({
        queryKey: ['transactions', 'detail', variables.transaction_id],
      })
      await queryClient.invalidateQueries({ queryKey: ['transactions'] })
      await queryClient.invalidateQueries({ queryKey: ['closing-balance'] })
      queryClient.invalidateQueries({ queryKey: ['vaults'] })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({
        queryKey: ['transaction-repeat-options'],
      })
      queryClient.invalidateQueries({ queryKey: ['todo-count'] })
      queryClient.invalidateQueries({ queryKey: ['todos', 'list'] })
      queryClient.invalidateQueries({
        queryKey: ['models'],
      })

      toast.success('Transaction series successfully added.')
    },
  })

  return {
    action: mutation.mutateAsync,
    status: mutation,
  }
}
